import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

export const styles = StyleSheet.create({
	container: {
		padding: 8,
		width: '100%',
		maxWidth: 860,
		boxSizing: 'border-box',
	},
	header: {
		color: THEME.colors.text.main,
		fontSize: '1.125rem',
		margin: '0 0 24px 0',
		fontWeight: 600,
	},
	content: {
		overflow: 'auto',
		maxHeight: 'calc(85vh - 100px)',
	},
});
